import React from 'react';
import { Typography, Box } from '@mui/material';
import { FlowStepBadge, type FlowStep } from './FlowStepBadge';

interface PageTitleProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  flowStep?: FlowStep;
}

export const PageTitle: React.FC<PageTitleProps> = ({ title, subtitle, actions, flowStep }) => {
  return (
    <Box sx={{ mb: 2, width: '100%' }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {flowStep && <FlowStepBadge step={flowStep} />}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: 'text.primary',
            }}
          >
            {title}
            {subtitle && (
              <Typography
                component="span"
                variant="subtitle2"
                sx={{
                  fontWeight: 400,
                  color: 'text.secondary',
                  ml: 1
                }}
              >
                - {subtitle}
              </Typography>
            )}
          </Typography>
        </Box>
        {actions && (
          <Box sx={{ ml: 2 }}>
            {actions}
          </Box>
        )}
      </Box>
    </Box>
  );
};